import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_EDGE_SERVER_ALL_GPUMETRICS,
    RESPOND_EDGE_SERVER_CREATE,
    RESPOND_EDGE_SERVER_DELETE,
    RESPOND_EDGE_SERVER_ENABLE,
    RESPOND_EDGE_SERVER_UPDATE,
    RESPOND_LIST_EDGE_SERVER,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import {
    EdgeServer,
    EdgeServerGpuMetrics,
    EdgeServerID,
} from "userful-chronos-app-common-js/dist/models/eisenhower/edgeSetup";
import { eisenhowerActions } from "../eisenhowerSlice";
import eisenhowerStore from "../eisenhowerStore";

registerMsgHandler(RESPOND_LIST_EDGE_SERVER, (payload) => {
    console.debug("receive RESPOND_LIST_EDGE_SERVER");
    const data = JSON.parse(payload) as EdgeServer[];
    eisenhowerStore.dispatch(eisenhowerActions.setListEdgeServer(data));
    // for(const server of data) {
    //     eisenhowerStore.dispatch(eisenhowerActions.requestListModelsToServer({ value: server.id.value }));
    // }
});

registerMsgHandler(RESPOND_EDGE_SERVER_CREATE, (payload) => {
    console.debug("receive RESPOND_EDGE_SERVER_CREATE");
    const data = JSON.parse(payload) as EdgeServer;
    eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateServer(data));
    eisenhowerStore.dispatch(eisenhowerActions.changeLoadState("RENDER"));
    eisenhowerStore.dispatch(eisenhowerActions.setOpenForm(false));
    // eisenhowerStore.dispatch(eisenhowerActions.setEditID(data.id.value));
    // eisenhowerStore.dispatch(eisenhowerActions.setCurrentNavigation("AddedModels"));
    eisenhowerStore.dispatch(eisenhowerActions.setShowEdgeRedirect(true));
});

registerMsgHandler(RESPOND_EDGE_SERVER_UPDATE, (payload) => {
    console.debug("receive RESPOND_EDGE_SERVER_UPDATE");
    const data = JSON.parse(payload) as EdgeServer;
    eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateServer(data));
    eisenhowerStore.dispatch(eisenhowerActions.changeLoadState("RENDER"));
    eisenhowerStore.dispatch(eisenhowerActions.setOpenForm(false));
});

registerMsgHandler(RESPOND_EDGE_SERVER_ENABLE, (payload) => {
    console.debug("receive RESPOND_EDGE_SERVER_ENABLE");
    const data = JSON.parse(payload) as EdgeServer;
    eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateServer(data));
});

registerMsgHandler(RESPOND_EDGE_SERVER_DELETE, (payload) => {
    const data = JSON.parse(payload) as EdgeServerID;
    eisenhowerStore.dispatch(eisenhowerActions.removeServer(data));
});

registerMsgHandler(RESPOND_EDGE_SERVER_ALL_GPUMETRICS, (payload) => {
    const data = JSON.parse(payload) as EdgeServerGpuMetrics[];
    eisenhowerStore.dispatch(eisenhowerActions.setAllGPUMetrics(data));
});
